import api from './api'

export interface RcsSessionInfo {
  sessionId: string
  status: 'disconnected' | 'pending_auth' | 'authenticated' | 'error' | string
  lastQrAt: number | null
  lastAuthenticatedAt: number | null
  lastError: string | null
}

export interface RcsExecutionLogItem {
  id: string
  sessionId: string
  phone: string
  textPreview: string
  success: boolean
  messageType: string
  error: string | null
  startedAt: number
  durationMs: number
}

export interface RcsTasksSnapshot {
  channelsRegistered: string[]
  sessions: RcsSessionInfo[]
  recentExecutions: RcsExecutionLogItem[]
}

export interface RcsExecuteRequest {
  numberId: string
  phone: string
  text: string
  localImagePath?: string
}

export interface RcsExecuteResponse {
  taskId: string
  status: string
  success: boolean | null
  messageType: string | null
  durationMs: number
  error: string | null
}

const RcsService = {
  async getTasks(): Promise<RcsTasksSnapshot> {
    const response = await api.get<RcsTasksSnapshot>('/monitoring/rcs/tasks')
    return response.data
  },

  async execute(payload: RcsExecuteRequest): Promise<RcsExecuteResponse> {
    const response = await api.post<RcsExecuteResponse>('/monitoring/rcs/execute', payload)
    return response.data
  },

  async startAuth(numberId: string): Promise<{ taskId: string; status: string; session: unknown }> {
    const response = await api.post<{ taskId: string; status: string; session: unknown }>(
      '/monitoring/rcs/auth',
      { numberId },
    )
    return response.data
  },

  async getLogs(limit = 50): Promise<{ items: RcsExecutionLogItem[]; count: number }> {
    const response = await api.get<{ items: RcsExecutionLogItem[]; count: number }>(
      '/monitoring/rcs/logs',
      { params: { limit } },
    )
    return response.data
  },
}

export default RcsService
